// name of the constant = route name in lower case
const vehicledetail = [
  { id: 0, title: 'Vehicle Number', colSpan: 3, column: 'number', show: true },
  { id: 1, title: 'Vehicle Type', colSpan: 2, column: 'vehicle_type', truncatedOn: 10, show: true },
  { id: 2, title: 'Vehicle Model', colSpan: 3, column: 'vehicle_model', truncatedOn: 10, show: true },
  { id: 3, title: 'Transporter Name', colSpan: 3, column: 'transporter', truncatedOn: 10, show: true },
  { id: 4, title: 'Chasis Number', colSpan: 4, column: 'chasis_number', truncatedOn: 10, show: true },
  { id: 5, title: 'Vehicle available In', colSpan: 5, column: 'depot_availability', wordTruncateOn: 26, show: true },
];

const users = [
  { id: 0, title: 'Name', column: 'name', tlabel: 'MDM_NAME', truncateOn: 20, show: true, colSpan: 3 },
  { id: 1, title: 'Role', column: 'account_role', tlabel: 'MDM_ROLE', show: true, colSpan: 3 },
  { id: 2, title: 'Status', column: 'status', tlabel: 'MDM_STATUS', show: true, colSpan: 3 },
  { id: 3, title: 'Phone', column: 'mobile', tlabel: 'MDM_PHONE', show: true, colSpan: 3 },
  { id: 4, title: 'EMAIL', column: 'email', tlabel: 'MDM_EMAIL', truncateOn: 20, show: true, colSpan: 3 },
  { id: 5, title: 'Depot', column: 'depot_ids', tlabel: 'MDM_DEPOT', show: true, colSpan: 3 },
];

const driverdetail = [
  { id: 0, title: 'Mobile Number', colSpan: 3, column: 'mobile_number', show: true, truncatedOn: 20 },
  { id: 1, title: 'Driver Name', colSpan: 3, column: 'driver_name', show: true, truncatedOn: 20 },
  { id: 2, title: 'Status', colSpan: 3, column: 'status', show: true, truncatedOn: 20 },
  { id: 3, title: 'Blacklist Status', colSpan: 3, column: 'blacklist_status', show: true, truncatedOn: 20 },
  { id: 4, title: 'License Number', colSpan: 3, column: 'license_number', show: true, truncatedOn: 20 },
  { id: 5, title: 'Medical Start Date', colSpan: 3, column: 'medical_start_date', show: true, truncatedOn: 20 },
  { id: 6, title: 'Medical End Date', colSpan: 3, column: 'medical_end_date', show: true, truncatedOn: 20 },
];

const ndc_master = [
  { id: 0, title: 'Quarter', colSpan: 3, column: 'quarter_name', show: true },
  { id: 1, title: 'Clear NDC', colSpan: 2, column: 'cndc_label', show: true },
  { id: 2, title: 'NDC with Outstanding', colSpan: 3, column: 'ondc_label', show: true },
  { id: 3, title: 'Updated By', colSpan: 3, column: 'updated_by_type', show: true, truncateOn: 20 },
  { id: 4, title: 'Updated Date', colSpan: 2, column: 'updated_date', show: true, truncateOn: 12 },
];

export const listHeaders = {
  vehicledetail,
  driverdetail,
  users,
  ndc_master,
};
